import { render, staticRenderFns } from "./MemberHistory.vue?vue&type=template&id=5e57a35a&"
import script from "./MemberHistory.vue?vue&type=script&lang=js&"
export * from "./MemberHistory.vue?vue&type=script&lang=js&"
import style0 from "./MemberHistory.vue?vue&type=style&index=0&id=5e57a35a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports